
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-e7a6ef2005";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? "" : pathForCanonical === "" ? "" : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("kIM6T", function(module, exports) {

var $eDehO = parcelRequire("eDehO");

var $3zPSM = parcelRequire("3zPSM");

var $lUcgp = parcelRequire("lUcgp");

var $kguP2 = parcelRequire("kguP2");

var $fy2QK = parcelRequire("fy2QK");

var $all0A = parcelRequire("all0A");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f15d3c6271cf3ba4$var$Stack(entries) {
    var data = this.__data__ = new $eDehO(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$f15d3c6271cf3ba4$var$Stack.prototype.clear = $3zPSM;
$f15d3c6271cf3ba4$var$Stack.prototype['delete'] = $lUcgp;
$f15d3c6271cf3ba4$var$Stack.prototype.get = $kguP2;
$f15d3c6271cf3ba4$var$Stack.prototype.has = $fy2QK;
$f15d3c6271cf3ba4$var$Stack.prototype.set = $all0A;
module.exports = $f15d3c6271cf3ba4$var$Stack;

});
parcelRegister("3zPSM", function(module, exports) {

var $eDehO = parcelRequire("eDehO");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $29ace2c6d3207ea0$var$stackClear() {
    this.__data__ = new $eDehO;
    this.size = 0;
}
module.exports = $29ace2c6d3207ea0$var$stackClear;

});

parcelRegister("lUcgp", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ff28573e0b4321e0$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $ff28573e0b4321e0$var$stackDelete;

});

parcelRegister("kguP2", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ec0d35f1384f2d1d$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $ec0d35f1384f2d1d$var$stackGet;

});

parcelRegister("fy2QK", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b51c3de59d2ccb15$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $b51c3de59d2ccb15$var$stackHas;

});

parcelRegister("all0A", function(module, exports) {

var $eDehO = parcelRequire("eDehO");

var $8IbLS = parcelRequire("8IbLS");

var $jCpAW = parcelRequire("jCpAW");
/** Used as the size to enable large array optimizations. */ var $787c2968852d0c5a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $787c2968852d0c5a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $eDehO) {
        var pairs = data.__data__;
        if (!$8IbLS || pairs.length < $787c2968852d0c5a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $jCpAW(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $787c2968852d0c5a$var$stackSet;

});


parcelRegister("gEINE", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/** Built-in value references. */ var $c203221415f41931$var$Uint8Array = $bBiRC.Uint8Array;
module.exports = $c203221415f41931$var$Uint8Array;

});

parcelRegister("lk7RV", function(module, exports) {

var $3eEUA = parcelRequire("3eEUA");

var $dgk1F = parcelRequire("dgk1F");

var $lrU6c = parcelRequire("lrU6c");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f86191c8c7318196$var$getAllKeys(object) {
    return $3eEUA(object, $lrU6c, $dgk1F);
}
module.exports = $f86191c8c7318196$var$getAllKeys;

});
parcelRegister("3eEUA", function(module, exports) {

var $4jLK2 = parcelRequire("4jLK2");

var $lPKNl = parcelRequire("lPKNl");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $25b26a18cffa7dd2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $lPKNl(object) ? result : $4jLK2(result, symbolsFunc(object));
}
module.exports = $25b26a18cffa7dd2$var$baseGetAllKeys;

});
parcelRegister("4jLK2", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $324df84505b66cc8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $324df84505b66cc8$var$arrayPush;

});


parcelRegister("dgk1F", function(module, exports) {

var $eRDHU = parcelRequire("eRDHU");

var $hJ191 = parcelRequire("hJ191");
/** Used for built-in method references. */ var $9a7c4daf90bb6692$var$objectProto = Object.prototype;
/** Built-in value references. */ var $9a7c4daf90bb6692$var$propertyIsEnumerable = $9a7c4daf90bb6692$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9a7c4daf90bb6692$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $9a7c4daf90bb6692$var$getSymbols = !$9a7c4daf90bb6692$var$nativeGetSymbols ? $hJ191 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $eRDHU($9a7c4daf90bb6692$var$nativeGetSymbols(object), function(symbol) {
        return $9a7c4daf90bb6692$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $9a7c4daf90bb6692$var$getSymbols;

});
parcelRegister("eRDHU", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ad24d0fa01a20a72$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $ad24d0fa01a20a72$var$arrayFilter;

});

parcelRegister("hJ191", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $ce7786e945828a84$var$stubArray() {
    return [];
}
module.exports = $ce7786e945828a84$var$stubArray;

});



parcelRegister("fMIy0", function(module, exports) {

var $4w1PP = parcelRequire("4w1PP");

var $8IbLS = parcelRequire("8IbLS");

var $9R3rT = parcelRequire("9R3rT");

var $2a3F6 = parcelRequire("2a3F6");

var $614Hw = parcelRequire("614Hw");

var $2EKmr = parcelRequire("2EKmr");

var $j0oFE = parcelRequire("j0oFE");
/** `Object#toString` result references. */ var $b7dde4eb65678917$var$mapTag = '[object Map]', $b7dde4eb65678917$var$objectTag = '[object Object]', $b7dde4eb65678917$var$promiseTag = '[object Promise]', $b7dde4eb65678917$var$setTag = '[object Set]', $b7dde4eb65678917$var$weakMapTag = '[object WeakMap]';
var $b7dde4eb65678917$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $b7dde4eb65678917$var$dataViewCtorString = $j0oFE($4w1PP), $b7dde4eb65678917$var$mapCtorString = $j0oFE($8IbLS), $b7dde4eb65678917$var$promiseCtorString = $j0oFE($9R3rT), $b7dde4eb65678917$var$setCtorString = $j0oFE($2a3F6), $b7dde4eb65678917$var$weakMapCtorString = $j0oFE($614Hw);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b7dde4eb65678917$var$getTag = $2EKmr;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($4w1PP && $b7dde4eb65678917$var$getTag(new $4w1PP(new ArrayBuffer(1))) != $b7dde4eb65678917$var$dataViewTag || $8IbLS && $b7dde4eb65678917$var$getTag(new $8IbLS) != $b7dde4eb65678917$var$mapTag || $9R3rT && $b7dde4eb65678917$var$getTag($9R3rT.resolve()) != $b7dde4eb65678917$var$promiseTag || $2a3F6 && $b7dde4eb65678917$var$getTag(new $2a3F6) != $b7dde4eb65678917$var$setTag || $614Hw && $b7dde4eb65678917$var$getTag(new $614Hw) != $b7dde4eb65678917$var$weakMapTag) $b7dde4eb65678917$var$getTag = function(value) {
    var result = $2EKmr(value), Ctor = result == $b7dde4eb65678917$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $j0oFE(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $b7dde4eb65678917$var$dataViewCtorString:
            return $b7dde4eb65678917$var$dataViewTag;
        case $b7dde4eb65678917$var$mapCtorString:
            return $b7dde4eb65678917$var$mapTag;
        case $b7dde4eb65678917$var$promiseCtorString:
            return $b7dde4eb65678917$var$promiseTag;
        case $b7dde4eb65678917$var$setCtorString:
            return $b7dde4eb65678917$var$setTag;
        case $b7dde4eb65678917$var$weakMapCtorString:
            return $b7dde4eb65678917$var$weakMapTag;
    }
    return result;
};
module.exports = $b7dde4eb65678917$var$getTag;

});
parcelRegister("4w1PP", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $349b92f9a7fb06f9$var$DataView = $4jmfA($bBiRC, 'DataView');
module.exports = $349b92f9a7fb06f9$var$DataView;

});

parcelRegister("9R3rT", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $72cbbd2d95e590d9$var$Promise = $4jmfA($bBiRC, 'Promise');
module.exports = $72cbbd2d95e590d9$var$Promise;

});

parcelRegister("2a3F6", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $192f5b1ee45264ad$var$Set = $4jmfA($bBiRC, 'Set');
module.exports = $192f5b1ee45264ad$var$Set;

});

parcelRegister("614Hw", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $46167b9446278235$var$WeakMap = $4jmfA($bBiRC, 'WeakMap');
module.exports = $46167b9446278235$var$WeakMap;

});


parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});

parcelRegister("46Ma8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fdd15086956a812$var$_react = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2fdd15086956a812$var$_baseNew = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2fdd15086956a812$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fdd15086956a812$var$AddIcon = (props)=>/*#__PURE__*/ $2fdd15086956a812$var$_react.default.createElement($2fdd15086956a812$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$2fdd15086956a812$var$AddIcon.displayName = 'AddIcon';
var $2fdd15086956a812$var$_default = module.exports.default = $2fdd15086956a812$var$AddIcon;

});

parcelRegister("5RBBI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $444f1300adfdb621$var$_react = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $444f1300adfdb621$var$_baseNew = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $444f1300adfdb621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $444f1300adfdb621$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $444f1300adfdb621$var$_react.default.createElement($444f1300adfdb621$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$444f1300adfdb621$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $444f1300adfdb621$var$_default = module.exports.default = $444f1300adfdb621$var$ChevronDownIcon;

});

parcelRegister("b7lH6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d32cfb464fc797f765cf705a7186f08e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81812d2b521be69e$var$_react = $81812d2b521be69e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $81812d2b521be69e$var$_baseNew = $81812d2b521be69e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $81812d2b521be69e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81812d2b521be69e$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $81812d2b521be69e$var$_react.default.createElement($81812d2b521be69e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$81812d2b521be69e$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $81812d2b521be69e$var$_default = module.exports.default = $81812d2b521be69e$var$LinkBrokenIcon;

});

parcelRegister("deg4B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a190cfac3d772e7$var$_react = $9a190cfac3d772e7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9a190cfac3d772e7$var$_baseNew = $9a190cfac3d772e7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $9a190cfac3d772e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a190cfac3d772e7$var$LinkIcon = (props)=>/*#__PURE__*/ $9a190cfac3d772e7$var$_react.default.createElement($9a190cfac3d772e7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$9a190cfac3d772e7$var$LinkIcon.displayName = 'LinkIcon';
var $9a190cfac3d772e7$var$_default = module.exports.default = $9a190cfac3d772e7$var$LinkIcon;

});

parcelRegister("jEVVm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9BZqy"));

});
parcelRegister("9BZqy", function(module, exports) {
$parcel$export(module.exports, "unstable_now", function () { return $6ff737efae05bc89$export$c4744153514ff05d; }, function (v) { return $6ff737efae05bc89$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7; }, function (v) { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ff737efae05bc89$export$e26fe2ed2fa76875; }, function (v) { return $6ff737efae05bc89$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ff737efae05bc89$export$502329bbf4b505b1; }, function (v) { return $6ff737efae05bc89$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ff737efae05bc89$export$6e3807111c4874c4; }, function (v) { return $6ff737efae05bc89$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ff737efae05bc89$export$c27134553091fb3a; }, function (v) { return $6ff737efae05bc89$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ff737efae05bc89$export$33ee1acdc04fd2a2; }, function (v) { return $6ff737efae05bc89$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ff737efae05bc89$export$b00a404bbd5edef2; }, function (v) { return $6ff737efae05bc89$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ff737efae05bc89$export$d66a1c1c77bd778b; }, function (v) { return $6ff737efae05bc89$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ff737efae05bc89$export$d3dfb8e4810cb555; }, function (v) { return $6ff737efae05bc89$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ff737efae05bc89$export$72fdf0e06517287b; }, function (v) { return $6ff737efae05bc89$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ff737efae05bc89$export$816d2913ae6b83b1; }, function (v) { return $6ff737efae05bc89$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ff737efae05bc89$export$61bcfe829111a1d0; }, function (v) { return $6ff737efae05bc89$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ff737efae05bc89$export$7ee8c9beb337bc3f; }, function (v) { return $6ff737efae05bc89$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ff737efae05bc89$export$b5836b71941fa3ed; }, function (v) { return $6ff737efae05bc89$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ff737efae05bc89$export$cf845f2c119da08a; }, function (v) { return $6ff737efae05bc89$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ff737efae05bc89$export$c4744153514ff05d;
var $6ff737efae05bc89$export$3e506c1ccc9cc1a7;
var $6ff737efae05bc89$export$e26fe2ed2fa76875;
var $6ff737efae05bc89$export$502329bbf4b505b1;
var $6ff737efae05bc89$export$6e3807111c4874c4;
var $6ff737efae05bc89$export$c27134553091fb3a;
var $6ff737efae05bc89$export$33ee1acdc04fd2a2;
var $6ff737efae05bc89$export$b00a404bbd5edef2;
var $6ff737efae05bc89$export$d66a1c1c77bd778b;
var $6ff737efae05bc89$export$d3dfb8e4810cb555;
var $6ff737efae05bc89$export$72fdf0e06517287b;
var $6ff737efae05bc89$export$816d2913ae6b83b1;
var $6ff737efae05bc89$export$61bcfe829111a1d0;
var $6ff737efae05bc89$export$7ee8c9beb337bc3f;
var $6ff737efae05bc89$export$b5836b71941fa3ed;
var $6ff737efae05bc89$export$cf845f2c119da08a;
"use strict";
function $6ff737efae05bc89$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6ff737efae05bc89$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6ff737efae05bc89$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6ff737efae05bc89$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6ff737efae05bc89$var$compare(left, last)) rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6ff737efae05bc89$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6ff737efae05bc89$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ff737efae05bc89$var$localPerformance = performance;
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localPerformance.now();
    };
} else {
    var $6ff737efae05bc89$var$localDate = Date, $6ff737efae05bc89$var$initialTime = $6ff737efae05bc89$var$localDate.now();
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localDate.now() - $6ff737efae05bc89$var$initialTime;
    };
}
var $6ff737efae05bc89$var$taskQueue = [], $6ff737efae05bc89$var$timerQueue = [], $6ff737efae05bc89$var$taskIdCounter = 1, $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = 3, $6ff737efae05bc89$var$isPerformingWork = !1, $6ff737efae05bc89$var$isHostCallbackScheduled = !1, $6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$needsPaint = !1, $6ff737efae05bc89$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6ff737efae05bc89$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6ff737efae05bc89$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6ff737efae05bc89$var$advanceTimers(currentTime) {
    for(var timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue);
        else if (timer.startTime <= currentTime) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue), timer.sortIndex = timer.expirationTime, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, timer);
        else break;
        timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
    }
}
function $6ff737efae05bc89$var$handleTimeout(currentTime) {
    $6ff737efae05bc89$var$isHostTimeoutScheduled = !1;
    $6ff737efae05bc89$var$advanceTimers(currentTime);
    if (!$6ff737efae05bc89$var$isHostCallbackScheduled) {
        if (null !== $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue)) $6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6ff737efae05bc89$var$isMessageLoopRunning = !1, $6ff737efae05bc89$var$taskTimeoutID = -1, $6ff737efae05bc89$var$frameInterval = 5, $6ff737efae05bc89$var$startTime = -1;
function $6ff737efae05bc89$var$shouldYieldToHost() {
    return $6ff737efae05bc89$var$needsPaint ? !0 : $6ff737efae05bc89$export$c4744153514ff05d() - $6ff737efae05bc89$var$startTime < $6ff737efae05bc89$var$frameInterval ? !1 : !0;
}
function $6ff737efae05bc89$var$performWorkUntilDeadline() {
    $6ff737efae05bc89$var$needsPaint = !1;
    if ($6ff737efae05bc89$var$isMessageLoopRunning) {
        var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
        $6ff737efae05bc89$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6ff737efae05bc89$var$isHostCallbackScheduled = !1;
                $6ff737efae05bc89$var$isHostTimeoutScheduled && ($6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1);
                $6ff737efae05bc89$var$isPerformingWork = !0;
                var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
                try {
                    b: {
                        $6ff737efae05bc89$var$advanceTimers(currentTime);
                        for($6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue); null !== $6ff737efae05bc89$var$currentTask && !($6ff737efae05bc89$var$currentTask.expirationTime > currentTime && $6ff737efae05bc89$var$shouldYieldToHost());){
                            var callback = $6ff737efae05bc89$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6ff737efae05bc89$var$currentTask.callback = null;
                                $6ff737efae05bc89$var$currentPriorityLevel = $6ff737efae05bc89$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6ff737efae05bc89$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6ff737efae05bc89$var$currentTask.callback = continuationCallback;
                                    $6ff737efae05bc89$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6ff737efae05bc89$var$currentTask === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                                $6ff737efae05bc89$var$advanceTimers(currentTime);
                            } else $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                            $6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue);
                        }
                        if (null !== $6ff737efae05bc89$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
                            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel, $6ff737efae05bc89$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline() : $6ff737efae05bc89$var$isMessageLoopRunning = !1;
        }
    }
}
var $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6ff737efae05bc89$var$localSetImmediate) $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetImmediate($6ff737efae05bc89$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ff737efae05bc89$var$channel = new MessageChannel(), $6ff737efae05bc89$var$port = $6ff737efae05bc89$var$channel.port2;
    $6ff737efae05bc89$var$channel.port1.onmessage = $6ff737efae05bc89$var$performWorkUntilDeadline;
    $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
        $6ff737efae05bc89$var$port.postMessage(null);
    };
} else $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetTimeout($6ff737efae05bc89$var$performWorkUntilDeadline, 0);
};
function $6ff737efae05bc89$var$requestHostTimeout(callback, ms) {
    $6ff737efae05bc89$var$taskTimeoutID = $6ff737efae05bc89$var$localSetTimeout(function() {
        callback($6ff737efae05bc89$export$c4744153514ff05d());
    }, ms);
}
$6ff737efae05bc89$export$3e506c1ccc9cc1a7 = 5;
$6ff737efae05bc89$export$e26fe2ed2fa76875 = 1;
$6ff737efae05bc89$export$502329bbf4b505b1 = 4;
$6ff737efae05bc89$export$6e3807111c4874c4 = 3;
$6ff737efae05bc89$export$c27134553091fb3a = null;
$6ff737efae05bc89$export$33ee1acdc04fd2a2 = 2;
$6ff737efae05bc89$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6ff737efae05bc89$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ff737efae05bc89$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6ff737efae05bc89$export$d3dfb8e4810cb555 = function() {
    return $6ff737efae05bc89$var$currentPriorityLevel;
};
$6ff737efae05bc89$export$72fdf0e06517287b = function(eventHandler) {
    switch($6ff737efae05bc89$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$816d2913ae6b83b1 = function() {
    $6ff737efae05bc89$var$needsPaint = !0;
};
$6ff737efae05bc89$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6ff737efae05bc89$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$timerQueue, priorityLevel), null === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && priorityLevel === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue) && ($6ff737efae05bc89$var$isHostTimeoutScheduled ? ($6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1) : $6ff737efae05bc89$var$isHostTimeoutScheduled = !0, $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, priorityLevel), $6ff737efae05bc89$var$isHostCallbackScheduled || $6ff737efae05bc89$var$isPerformingWork || ($6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6ff737efae05bc89$export$b5836b71941fa3ed = $6ff737efae05bc89$var$shouldYieldToHost;
$6ff737efae05bc89$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
        $6ff737efae05bc89$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("ixLXc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bOBs2"));

});
parcelRegister("bOBs2", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", function () { return $89a16a416bb12add$export$306c0aa65ff9ec16; }, function (v) { return $89a16a416bb12add$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89a16a416bb12add$export$306c0aa65ff9ec16;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $89a16a416bb12add$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $89a16a416bb12add$var$k = "function" === typeof Object.is ? Object.is : $89a16a416bb12add$var$h, $89a16a416bb12add$var$l = $1oC0p.useState, $89a16a416bb12add$var$m = $1oC0p.useEffect, $89a16a416bb12add$var$n = $1oC0p.useLayoutEffect, $89a16a416bb12add$var$p = $1oC0p.useDebugValue;
function $89a16a416bb12add$var$q(a, b) {
    var d = b(), f = $89a16a416bb12add$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $89a16a416bb12add$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $89a16a416bb12add$var$m(function() {
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $89a16a416bb12add$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $89a16a416bb12add$var$p(d);
    return d;
}
function $89a16a416bb12add$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$89a16a416bb12add$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $89a16a416bb12add$var$t(a, b) {
    return b();
}
var $89a16a416bb12add$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $89a16a416bb12add$var$t : $89a16a416bb12add$var$q;
$89a16a416bb12add$export$306c0aa65ff9ec16 = void 0 !== $1oC0p.useSyncExternalStore ? $1oC0p.useSyncExternalStore : $89a16a416bb12add$var$u;

});


parcelRegister("fl7Kz", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("92jF6")).Card; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("92jF6")).Card; });

var $92jF6 = parcelRequire("92jF6");

});
parcelRegister("92jF6", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b6adcd00aae9005f$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2tb46 = parcelRequire("2tb46");
const $b6adcd00aae9005f$var$containerStyles = null;
const $b6adcd00aae9005f$var$contentBlockStyles = null;
const $b6adcd00aae9005f$var$barStyles = null;
const $b6adcd00aae9005f$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor ?? "#ffffff";
    const cardBackTextColor = textColor ?? "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor ?? "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $6ZVlx.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $6ZVlx.default)(cardBackTextColor),
            "--_8vvi5m": (0, $6ZVlx.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2jatx.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("8EEDU", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("hBYvx")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("hBYvx")).Video; });

var $hBYvx = parcelRequire("hBYvx");

});
parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return {
        maxWidth: "100%",
        ...aspectRatioCSS
    };
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});


parcelRegister("53RJr", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("jVACb")).BannerAlert; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("jVACb")).BannerAlert; });

var $jVACb = parcelRequire("jVACb");

});
parcelRegister("jVACb", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return $8326461e03189c88$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");

var $2gCne = parcelRequire("2gCne");
const $8326461e03189c88$var$containerStyles = null;
const $8326461e03189c88$var$contentStyles = null;
const $8326461e03189c88$var$closeIconStyles = null;
const $8326461e03189c88$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $8e22h.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $2jatx.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $2jatx.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("cBRzT", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $92e2802c3f3faa2d$export$f04a61298a47a40f; });

var $j5iXZ = parcelRequire("j5iXZ");

var $f4dRo = parcelRequire("f4dRo");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $7bjkc = parcelRequire("7bjkc");

var $ePzZI = parcelRequire("ePzZI");

var $2T05n = parcelRequire("2T05n");
function $92e2802c3f3faa2d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $92e2802c3f3faa2d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $92e2802c3f3faa2d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f4dRo.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $92e2802c3f3faa2d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $92e2802c3f3faa2d$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': $92e2802c3f3faa2d$var$_objectSpread($92e2802c3f3faa2d$var$_objectSpread({}, (0, $2T05n.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $92e2802c3f3faa2d$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $92e2802c3f3faa2d$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $92e2802c3f3faa2d$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $92e2802c3f3faa2d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $2T05n.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $7bjkc.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("span", (0, $j5iXZ.default)({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $ePzZI.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $92e2802c3f3faa2d$var$iconStyles,
            $92e2802c3f3faa2d$var$baseHcmStyles,
            primaryColor === secondaryColor && $92e2802c3f3faa2d$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $92e2802c3f3faa2d$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $3dJ4i.css)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $92e2802c3f3faa2d$export$2e2bcd8739ae039 = $92e2802c3f3faa2d$export$f04a61298a47a40f;

});
parcelRegister("j5iXZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de4d32501cbaa890$export$2e2bcd8739ae039; });
function $de4d32501cbaa890$export$2e2bcd8739ae039() {
    return $de4d32501cbaa890$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $de4d32501cbaa890$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("f4dRo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af81fb11f20b4dbf$export$2e2bcd8739ae039; });

var $gPZ2W = parcelRequire("gPZ2W");
function $af81fb11f20b4dbf$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gPZ2W.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("gPZ2W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c420c34ad2881120$export$2e2bcd8739ae039; });

var $9ZcxL = parcelRequire("9ZcxL");

var $a0eM0 = parcelRequire("a0eM0");
function $c420c34ad2881120$export$2e2bcd8739ae039(t) {
    var i = (0, $a0eM0.default)(t, "string");
    return "symbol" == (0, $9ZcxL.default)(i) ? i : i + "";
}

});
parcelRegister("9ZcxL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74538a79640a74ac$export$2e2bcd8739ae039; });
function $74538a79640a74ac$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $74538a79640a74ac$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $74538a79640a74ac$export$2e2bcd8739ae039(o);
}

});

parcelRegister("a0eM0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74855d28c2077da5$export$2e2bcd8739ae039; });

var $9ZcxL = parcelRequire("9ZcxL");
function $74855d28c2077da5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $9ZcxL.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $9ZcxL.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7bjkc", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $53a88cfe98fdf71d$export$7692396083754928; });

var $cxQhM = parcelRequire("cxQhM");
// Create default global light theme
var $53a88cfe98fdf71d$var$_createTheme = (0, $cxQhM.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $53a88cfe98fdf71d$var$Provider = $53a88cfe98fdf71d$var$_createTheme.Provider, $53a88cfe98fdf71d$var$Consumer = $53a88cfe98fdf71d$var$_createTheme.Consumer, $53a88cfe98fdf71d$export$7692396083754928 = $53a88cfe98fdf71d$var$_createTheme.useTheme;
var $53a88cfe98fdf71d$export$2e2bcd8739ae039 = {
    Provider: $53a88cfe98fdf71d$var$Provider,
    Consumer: $53a88cfe98fdf71d$var$Consumer
};

});
parcelRegister("cxQhM", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $92211ff8e272fcf3$export$25d302a5b900a763; });

var $hbMSe = parcelRequire("hbMSe");

var $1oC0p = parcelRequire("1oC0p");
var $92211ff8e272fcf3$var$_excluded = [
    "children"
];
function $92211ff8e272fcf3$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $hbMSe.default)(props, $92211ff8e272fcf3$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("hbMSe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c83960118bdb5237$export$2e2bcd8739ae039; });

var $kNa4S = parcelRequire("kNa4S");
function $c83960118bdb5237$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $kNa4S.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("kNa4S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2303371223ab2e5$export$2e2bcd8739ae039; });
function $f2303371223ab2e5$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("ePzZI", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $acc1bfd6f6771c37$export$18cb9425622d4e06; });
var $acc1bfd6f6771c37$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $acc1bfd6f6771c37$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
    return $acc1bfd6f6771c37$var$themedBackground[mode];
};

});

parcelRegister("2T05n", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $21a0c8d570a57771$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $21a0c8d570a57771$export$3eb7d6130acfda37; });

var $kyKK7 = parcelRequire("kyKK7");

var $3dJ4i = parcelRequire("3dJ4i");
var $21a0c8d570a57771$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $21a0c8d570a57771$var$smallStyles = (0, $3dJ4i.css)((0, $kyKK7.dimensions).small);
var $21a0c8d570a57771$var$mediumStyles = (0, $3dJ4i.css)((0, $kyKK7.dimensions).medium);
var $21a0c8d570a57771$var$largeStyles = (0, $3dJ4i.css)((0, $kyKK7.dimensions).large);
var $21a0c8d570a57771$var$xlargeStyles = (0, $3dJ4i.css)((0, $kyKK7.dimensions).xlarge);
var $21a0c8d570a57771$export$ef0ad74202575b64 = {
    small: $21a0c8d570a57771$var$smallStyles,
    medium: $21a0c8d570a57771$var$mediumStyles,
    large: $21a0c8d570a57771$var$largeStyles,
    xlarge: $21a0c8d570a57771$var$xlargeStyles
};
var $21a0c8d570a57771$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $kyKK7.dimensions)[size];
    return undefined;
};

});
parcelRegister("kyKK7", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $ef7b3dca63f74e4a$export$62ad7b0c781000e9; });
var $ef7b3dca63f74e4a$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $ef7b3dca63f74e4a$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $ef7b3dca63f74e4a$export$62ad7b0c781000e9 = {
    small: {
        width: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.small,
        height: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.medium,
        height: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.large,
        height: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.xlarge,
        height: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("7eewv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54351b3d8fb90994$var$_react = $54351b3d8fb90994$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cBRzT = parcelRequire("cBRzT");
function $54351b3d8fb90994$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $54351b3d8fb90994$var$Story16Icon = (props)=>/*#__PURE__*/ $54351b3d8fb90994$var$_react.default.createElement($cBRzT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 11l-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426L8 11zm0-2.371l2 1.274V5H6v4.902L8 8.63z"/></svg>`
    }, props, {
        size: "small"
    }));
$54351b3d8fb90994$var$Story16Icon.displayName = 'Story16Icon';
var $54351b3d8fb90994$var$_default = $54351b3d8fb90994$var$Story16Icon;
module.exports.default = $54351b3d8fb90994$var$_default;

});

parcelRegister("5WMok", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4547e807fcbff5a7$var$_react = $4547e807fcbff5a7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4547e807fcbff5a7$var$_baseNew = $4547e807fcbff5a7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4547e807fcbff5a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4547e807fcbff5a7$var$RefreshIcon = (props)=>/*#__PURE__*/ $4547e807fcbff5a7$var$_react.default.createElement($4547e807fcbff5a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$4547e807fcbff5a7$var$RefreshIcon.displayName = 'RefreshIcon';
var $4547e807fcbff5a7$var$_default = module.exports.default = $4547e807fcbff5a7$var$RefreshIcon;

});

parcelRegister("8cFW9", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bBiRC.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("044AT", function(module, exports) {

var $jM7lD = parcelRequire("jM7lD");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $00c3f019a8ea1fc2$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jM7lD(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $00c3f019a8ea1fc2$var$cloneTypedArray;

});
parcelRegister("jM7lD", function(module, exports) {

var $gEINE = parcelRequire("gEINE");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e658332d980af196$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $gEINE(result).set(new $gEINE(arrayBuffer));
    return result;
}
module.exports = $e658332d980af196$var$cloneArrayBuffer;

});


parcelRegister("64IpJ", function(module, exports) {

var $6DkQS = parcelRequire("6DkQS");

var $iiMec = parcelRequire("iiMec");

var $1b6pL = parcelRequire("1b6pL");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $46c5917dd804d4c7$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$1b6pL(object) ? $6DkQS($iiMec(object)) : {};
}
module.exports = $46c5917dd804d4c7$var$initCloneObject;

});
parcelRegister("6DkQS", function(module, exports) {

var $ih96c = parcelRequire("ih96c");
/** Built-in value references. */ var $4d468f5c997304ff$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $4d468f5c997304ff$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$ih96c(proto)) return {};
        if ($4d468f5c997304ff$var$objectCreate) return $4d468f5c997304ff$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $4d468f5c997304ff$var$baseCreate;

});

parcelRegister("iiMec", function(module, exports) {

var $a8tXu = parcelRequire("a8tXu");
/** Built-in value references. */ var $d52f5187398d5cf2$var$getPrototype = $a8tXu(Object.getPrototypeOf, Object);
module.exports = $d52f5187398d5cf2$var$getPrototype;

});


parcelRegister("6mx2n", function(module, exports) {

var $c5uls = parcelRequire("c5uls");

var $h6ZSp = parcelRequire("h6ZSp");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $4a1e6cacd7634ff8$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $h6ZSp(object, key, newValue);
        else $c5uls(object, key, newValue);
    }
    return object;
}
module.exports = $4a1e6cacd7634ff8$var$copyObject;

});

parcelRegister("58mMQ", function(module, exports) {

var $94SbA = parcelRequire("94SbA");

var $gRjiS = parcelRequire("gRjiS");

var $6PGLN = parcelRequire("6PGLN");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $3bcf6012be1fceb8$var$keysIn(object) {
    return $6PGLN(object) ? $94SbA(object, true) : $gRjiS(object);
}
module.exports = $3bcf6012be1fceb8$var$keysIn;

});
parcelRegister("gRjiS", function(module, exports) {

var $ih96c = parcelRequire("ih96c");

var $1b6pL = parcelRequire("1b6pL");

var $d8aqD = parcelRequire("d8aqD");
/** Used for built-in method references. */ var $c46091dcf5529043$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c46091dcf5529043$var$hasOwnProperty = $c46091dcf5529043$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c46091dcf5529043$var$baseKeysIn(object) {
    if (!$ih96c(object)) return $d8aqD(object);
    var isProto = $1b6pL(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$c46091dcf5529043$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $c46091dcf5529043$var$baseKeysIn;

});
parcelRegister("d8aqD", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $98f41c9e4a4b76be$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $98f41c9e4a4b76be$var$nativeKeysIn;

});



parcelRegister("KrnvM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7Y7ZZ"));

});
parcelRegister("7Y7ZZ", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $5cd4576c4e69a9a0$export$bf730a2d8bf68b42; }, function (v) { return $5cd4576c4e69a9a0$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5cd4576c4e69a9a0$export$bf730a2d8bf68b42;
'use strict';

var $1oC0p = parcelRequire("1oC0p");

var $ixLXc = parcelRequire("ixLXc");
function $5cd4576c4e69a9a0$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5cd4576c4e69a9a0$var$q = "function" === typeof Object.is ? Object.is : $5cd4576c4e69a9a0$var$p, $5cd4576c4e69a9a0$var$r = $ixLXc.useSyncExternalStore, $5cd4576c4e69a9a0$var$t = $1oC0p.useRef, $5cd4576c4e69a9a0$var$u = $1oC0p.useEffect, $5cd4576c4e69a9a0$var$v = $1oC0p.useMemo, $5cd4576c4e69a9a0$var$w = $1oC0p.useDebugValue;
$5cd4576c4e69a9a0$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $5cd4576c4e69a9a0$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $5cd4576c4e69a9a0$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($5cd4576c4e69a9a0$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $5cd4576c4e69a9a0$var$r(a, c[0], c[1]);
    $5cd4576c4e69a9a0$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $5cd4576c4e69a9a0$var$w(d);
    return d;
};

});


parcelRegister("6UAxX", function(module, exports) {
$parcel$export(module.exports, "PatternLogos", function () { return (parcelRequire("9uL34")).PatternLogos; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("9uL34")).PatternLogos; });

var $9uL34 = parcelRequire("9uL34");

});
parcelRegister("9uL34", function(module, exports) {
$parcel$export(module.exports, "PatternLogos", function () { return $9ce6b13b299d308e$export$355432025e812df1; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");

var $2tb46 = parcelRequire("2tb46");

var $jMhSx = parcelRequire("jMhSx");
const $9ce6b13b299d308e$var$ConditionalLogo = (props)=>{
    if (props.link) return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: props.link,
        className: "logoblock logo-linked",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
            src: props.src,
            alt: props.alt,
            width: props.width,
            loading: "lazy"
        })
    });
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        className: "logoblock logo-plain",
        src: props.src,
        alt: props.alt,
        width: props.width,
        loading: "lazy"
    }));
};
const $9ce6b13b299d308e$export$355432025e812df1 = ({ inlineLogos: inlineLogos, headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, linkPosition: linkPosition = "top" })=>{
    if (inlineLogos.length < 4 || inlineLogos.length > 12) throw new Error("Minimum 4 logos required, maximum 12");
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916ud5o _1nk71e5h _jti51ul9 _xjyridpf _2thuidpf _hbr3idpf",
            className
        ]),
        children: [
            headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                    isCentered: true,
                    headerText: headerText,
                    headerType: "h2",
                    eyebrowText: eyebrowText,
                    bodyText: bodyText,
                    ctaProps: linkPosition == "top" && ctaProps?.primaryLinkProps ? ctaProps : undefined
                })
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: `logos-content lgth length-${inlineLogos.length}`,
                    children: inlineLogos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($9ce6b13b299d308e$var$ConditionalLogo, {
                            alt: inlineLogo.alt,
                            src: inlineLogo.src,
                            link: inlineLogo.link,
                            width: inlineLogo.width
                        }, index))
                })
            }),
            footNoteText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "footnote-text",
                    children: footNoteText
                })
            }) : null,
            linkPosition == "bottom" && ctaProps?.primaryLinkProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        ...ctaProps.primaryLinkProps
                    })
                })
            }) : null
        ]
    });
};

});



var $3NQOU = parcelRequire("3NQOU");

var $g4d4R = parcelRequire("g4d4R");
(0, $3NQOU.init)((0, $g4d4R.JiraSoftwareFeaturesPage));


//# sourceMappingURL=jira-software-features-page.7c4526a9.js.map
